<label #assetteam_selector_anchor (click)="onToggle()" style="cursor:pointer;user-select:none" [ngClass]="{'disabled': loading }">
  <kendo-svgicon [icon]="show ? icons.chevronDown : icons.chevronRight"></kendo-svgicon>
  <span class="scenario-label"></span>{{selectedTeam ? getAssetTeamName(selectedTeam.AssetTeamCode) : ''}}
</label>
@if (loading) {
  <kendo-loader type="converging-spinner" size="small" themeColor="base"></kendo-loader>
}
<div class="popup-wrapper">
  @if (show) {
    <kendo-popup #popup [popupClass]="'scenario-selector popup'" [anchor]="assetteam_selector_anchor"
      (anchorViewportLeave)="show = false">
      <ul class="k-list k-reset">
        @for (ateam of appStore.knownTables.assetTeams | async; track tracksFn($index, ateam); let i = $index) {
          <li class="k-item" (click)="selectTeam(ateam)">
            {{getAssetTeamName(ateam.AssetTeamCode)}}
          </li>
        }
      </ul>
    </kendo-popup>
  }
</div>